import { useTheme } from "@emotion/react";
import type { ComponentProps } from "react";
import { default as GradientColorPicker } from "react-best-gradient-color-picker";

export const ColorPicker = (props: ComponentProps<typeof GradientColorPicker>) => {
  const { type } = useTheme();
  return (
    <GradientColorPicker
      hidePresets
      hideInputs
      hideColorTypeBtns
      hideGradientControls
      disableDarkMode={type === "light"}
      hideControls
      width={200}
      height={200}
      {...props}
    />
  );
};
